export const urls = {
    main: '/',
    need: (need: string = ':needId') => `/need/${need}`,
    needSended: (need: string = ':needId') => `/need/${need}/sended`,
    adminLogin: '/admin',
    adminDashboard: '/admin/dashboard',
    adminLogout: '/admin/logout',
}